import React, { useEffect, useState } from "react";
import { Container, Table, Button, Form, Pagination, } from "react-bootstrap";
import { FiEdit, FiTrash2, FiPlus, } from "react-icons/fi";
import { useNavigate, Link } from "react-router-dom";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";

import { getInstitute } from "../../store/slices/institute";

export default function Institute() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [institutedata, setInstituteDate] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);


  const fetchInstitutes = (filterData = {}) => {
    setIsLoading(true);
    dispatch(getInstitute(filterData))
      .unwrap()
      .then((res) => {
        setInstituteDate(res?.data || []);
        setTotalData(res?.data?.length || 0);
        setCurrentPage(1);
      })
      .catch(() => {
        toast.error("Failed to fetch students");
        setInstituteDate([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchInstitutes();
  }, []);

  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = institutedata.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <div>
        {/* Top row */}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
          <div>
            <h2 className="fw-bold mb-1 fs-6 fs-md-5 fs-lg-4">
              Institutes
            </h2>

          </div>

          <div className="d-flex gap-2 gap-md-3">
            <Link
              to="/sadmin/add-institute"
              className="btn-submit d-flex align-items-center gap-2"
            >
              <FiPlus />
              <span className="d-none d-md-inline fs-6">Add Institute</span>
            </Link>
          </div>
        </div>

      </div>
      <Container fluid className="students-page">

        <div className="table-responsive">
          <Table className="students-table align-middle">
            <thead >
              <tr>
                <th><Form.Check /></th>
                <th>#</th>
                <th>Name</th>
                <th>Class-Sec</th>
                <th>Gender</th>
                <th>DOB</th>
                <th>Father's Name</th>
                <th>Father's Mobile</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody style={{ backgroundColor: "white" }}>
              {isLoading ? (
                <tr>
                  <td colSpan="9" className="text-center">Loading...</td>
                </tr>
              ) : paginatedData.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">No institute found</td>
                </tr>
              ) : (
                paginatedData.map((s, i) => (
                  <tr key={s._id || i}>
                    <td><Form.Check /></td>
                    <td>{startIndex + i + 1}</td>
                    <td className="d-flex align-items-center gap-2">
                      <img
                        src={s.instituteLogo || "/default-avatar.png"}
                        className="avatar"
                        alt="student"
                      />
                      {s.instituteName}
                    </td>
                    <td>{s.standardId?.name}-{s.sectionId?.name}</td>
                    <td>{s.gender}</td>
                    <td>{s.dob?.slice(0, 10)}</td>
                    <td>{s.parentId?.fatherName}</td>
                    <td>{s.parentId?.fatherMobileNo || "-"}</td>
                    <td className="actions">
                      <FiTrash2 />
                      <FiEdit onClick={() => navigate(`/institute/edit-student/${s._id}`)} />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>


        <div className="d-flex flex-row-reverse my-3">
          <Pagination>
            <Button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              style={{ background: "transparent", color: "#8451ff", marginRight: "2px", borderRadius: "15px", }}
            >
              <IoIosArrowBack />
            </Button>

            <Button active disabled style={{ marginRight: "2px", borderRadius: "20px" }}>{currentPage}</Button>

            <Button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              style={{ background: "transparent", color: "#8451ff", marginRight: "2px", borderRadius: "15px", }}
            >
              <IoIosArrowForward />
            </Button>
          </Pagination>
        </div>
      </Container>
    </>
  );
}
